"use client";

import * as React from "react";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    // Redirect to the root after a short delay (or immediately)
    router.replace("/");
  }, [router]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <Image
        priority
        src={"/static/images/gemini-hor-dark-full-rgb@3x.png"}
        alt="Gemini"
        width={161}
        height={35}
        style={{ cursor: "pointer" }}
      />
      <p className="pt-4 text-gray-700">
        This page does not exist. Redirecting you...
      </p>
    </div>
  );
}
